import React from "react";
import { Button } from "@chakra-ui/react";

const CommonButton = ({ 
  children, 
  onClick, 
  style, 
  type = null, 
  disabled = false, 
  inverted = false,
  round = true,
  visible = true,
}) => {
  if (!visible) return null;
  let sx;
  if (!inverted) {
    sx = {
      bg: "primary",
      color: `white`,
      border: 1,
      borderStyle: `solid`,
      borderColor: `blue.500`,
      _hover: {
        bg: `hover`,
      },
      _active: {
        bg: "blue.600",
      },
    };
  } else {
    sx = {
      bg: "white",
      color: `primary`,
      border: 1,
      borderStyle: `solid`,
      borderColor: `blue.500`,
      _hover: {
        bg: `hover`,
        color: `white`,
      },
      _active: {
        bg: "blue.600",
      },
    };
  }

  if (disabled) {
    sx['_hover'] = {};
    sx['_active'] = {};
  }

  if (round) {
    sx['borderRadius'] = `45px`;
  }
  
  return (
    <Button
      fontSize={14}
      fontWeight={`bold`}
      sx={sx}
      onClick={onClick}
      style={style}
      type={type}
      disabled={disabled}
    >
      {children}
    </Button>
  );
};

export default CommonButton;
